import api from '../api'

export const postPesticideManufacturer = (params) => api.post('/admin/defensives-makers', params)

export const putPesticideManufacturer = ({ id, ...params }) => api.put(`/admin/defensives-makers/${ id }`, params)

export const postPesticide = (params) => api.post('/admin/defensives', params)

export const putPesticide = ({ id, ...params }) => api.put(`/admin/defensives/${ id }`, params)

export const deletePesticide = ({ id }) => api.delete(`/admin/defensives/${ id }`)
